import { Snippets } from './snippets';
export class TagManager {
	public static dataScript(dataLayer: any) {
		const script = document.createElement('script');
		script.innerHTML = dataLayer;
		return script;
	}

	public static gtmTags(args: any) {
		const snippets = Snippets.tags(args);

		const noScript = () => {
			const noscript = document.createElement('noscript');
			noscript.innerHTML = snippets.iframe;
			return noscript;
		};

		const script = () => {
			const script = document.createElement('script');
			script.innerHTML = snippets.script;
			return script;
		};

		const dataScript = this.dataScript(snippets.dataLayerVar);

		return {
			noScript,
			script,
			dataScript,
		};
	}

	public static initialize({
		gtmId,
		events = {},
		dataLayer,
		dataLayerName = 'dataLayer',
		auth = '',
		preview = '',
	}: {
		gtmId?: string;
		events?: any;
		dataLayer?: any;
		dataLayerName?: string;
		auth?: string;
		preview?: string;
	}) {
		const gtm = TagManager.gtmTags({
			id: gtmId,
			events: events,
			dataLayer: dataLayer || undefined,
			dataLayerName: dataLayerName,
			auth,
			preview,
		});
		if (dataLayer) document.head.appendChild(gtm.dataScript);
		document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
		document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
	}

	public static dataLayer({ dataLayer, dataLayerName = 'dataLayer' }: { dataLayer?: any; dataLayerName?: string }) {
		if (window[dataLayerName]) return window[dataLayerName].push(dataLayer);
		const snippets = Snippets.dataLayer(dataLayer, dataLayerName);
		const dataScript = this.dataScript(snippets);
		document.head.insertBefore(dataScript, document.head.childNodes[0]);
	}
}
